import { colors, cbSemanticCssVars } from '@creditornot/cb-ingredients';
import { cssThemedValue } from '@creditornot/cb-sc-utils';
import React from 'react';
import styled from 'styled-components';

import { Typography } from 'common/typography';

type ChipProps = {
  label: string;
  isActive?: boolean;
  onClick?: () => void;
};

const Root = styled.div<{ isActive?: boolean; isClickable: boolean }>`
  display: flex;
  height: 32px;
  padding: 0 4px;
  align-items: center;
  justify-content: center;
  border-radius: 16px;
  cursor: ${({ isClickable }) => (isClickable ? 'pointer' : 'auto')};
  background-color: ${({ isActive }) =>
    isActive
      ? colors.wolt8
      : cssThemedValue({
          light: colors.pepper8,
          dark: colors.salt8,
        })};

  &:hover {
    background-color: ${({ isActive }) =>
      isActive
        ? colors.wolt8
        : cssThemedValue({
            light: colors.pepper16,
            dark: colors.salt16,
          })};
  }

  &:active {
    background-color: ${({ isActive }) =>
      isActive
        ? colors.wolt16
        : cssThemedValue({
            light: colors.pepper28,
            dark: colors.salt28,
          })};
  }
`;

const ChipLabel = styled(Typography.Body3)<{ isActive?: boolean }>`
  padding: 0 4px;
  align-items: center;
  color: ${({ isActive }) => (isActive ? colors.wolt100 : cbSemanticCssVars.textSecondary)};
  font-weight: 500;
`;

export const Chip = ({ label, isActive, onClick }: ChipProps) => {
  return (
    <Root isActive={isActive} onClick={onClick} isClickable={onClick !== undefined}>
      <ChipLabel isActive={isActive}>{label}</ChipLabel>
    </Root>
  );
};
